import React, { useEffect } from "react";

import { useAddSourceURL } from "@/api/knowledge-source/add-source-url";
import { Input } from "@/components/ui/input";
import useGlobalLoading from "@/store/global-loading";

import KnowledgeSourceButtons from "../knowledge-source-buttons/knowledge-source-buttons";
import useGlobalPermission from "@/store/user-permissions";

const SinglePageSource = () => {
    const [pageURL, setPageURL] = React.useState("");
    const handleAddSource = () => {
        addSourceURL({ url: pageURL });
    };

    const { mutate: addSourceURL, isPending, isSuccess } = useAddSourceURL();
    const { setIsLoading } = useGlobalLoading();
    useEffect(() => {
        setIsLoading(isPending);
        if (isSuccess) {
            setPageURL("");
        }
    }, [setIsLoading, isPending, isSuccess]);
    const { permissionList } = useGlobalPermission();
    const trainingPermission = permissionList.find((item) => item.module.name === "AI_Training");
    return (
        <div>
            <h3 className="mb-4 font-bold">Page URL</h3>
            <Input
                disabled={!trainingPermission?.can_create}
                className="mb-3 py-6"
                placeholder="Enter the page url here"
                value={pageURL}
                onChange={(e) => setPageURL(e.target.value)}
            />
            <p className="mb-4 text-sm">This action will save the information from this page only</p>
            <KnowledgeSourceButtons onSubmit={handleAddSource} loading={isPending} />
        </div>
    );
};

export default SinglePageSource;
